import { useQuery } from "@tanstack/react-query";
import { getAuditEntries } from "../../../../api/misc";
import { AuditActions, EventTypes } from "../../../../constants/Audit";
import { AuditResponseInterface } from "../../../../types/Audit";
import { convertEnumToText } from "../../../../utils";
import LoadingTimeline from "../../../UI/loading/LoadingTimeline";

export default function ApplicationTimeline({
  activity,
  resourceType,
  title,
}: {
  activity?: any;
  resourceType: string;
  title?: string;
}) {
  const fetchAuditEntries = useQuery(["application-audits", activity?.id], () =>
    getAuditEntries({
      params: {
        resource_type: resourceType,
        resource_id: activity?.id,
      },
    })
  );

  const activities = fetchAuditEntries?.data?.data;
  return (
    <>
      <div className="flex flex-col max-h-full bg-white shadow sm:rounded-lg divide-y">
        <div className="py-4">
          <h3
            id="timeline-title"
            className="font-bold px-6 py-3 font-medium m-0 border-l-4 border-primaryColor-normal">
            {title ?? "Timeline"}
          </h3>
        </div>
        <div className="flex-1 overflow-y-auto py-6 flow-root px-6">
          {fetchAuditEntries.isLoading && <LoadingTimeline />}
          {!fetchAuditEntries.isLoading && (
            <dl className="space-y-5">
              {activities?.map((act: AuditResponseInterface) => (
                <>
                  {act?.meta && act?.action && (
                    <div key={act.id} className="relative">
                      <dt>
                        <span
                          className="absolute left-1.5 top-4 h-full w-0.5 bg-gray-200"
                          aria-hidden="true"
                        />
                      </dt>
                      <dd className="flex gap-4">
                        <div>
                          <span className="p-1.5 rounded-full flex items-center justify-center bg-tertiaryColor-light"></span>
                        </div>
                        <div className="text-sm whitespace-wrap">
                          <p className="break-words">
                            <strong>{act.user.name}</strong>{" "}
                            {act.action &&
                              AuditActions[act.action].toLowerCase()}{" "}
                            the {act.meta && Object.keys(act.meta)} of this form
                            to{" "}
                            {act.meta &&
                              Object.keys(act.meta).map((key) =>
                                convertEnumToText(act.meta[key])
                              )}
                          </p>
                          <time
                            dateTime={activity?.createdAt}
                            className="text-xs text-neutralColor-normal">
                            {new Date(act?.createdAt).toDateString()}
                          </time>
                        </div>
                      </dd>
                    </div>
                  )}
                </>
              ))}
              <div className="min-w-0 -ml-2 flex space-x-4">
                <dt className="text-sm text-gray-500">
                  <span className="p-1 bg-neutralColor-lighter rounded-full flex items-center justify-center">
                    {EventTypes["SUBMITTED"].icon}
                  </span>
                </dt>
                <dd className="flex flex-col text-sm whitespace-nowrap text-gray-500">
                  <span>Application Received</span>
                  <time dateTime={activity?.createdAt} className="text-xs">
                    {new Date(activity?.createdAt).toDateString()}
                  </time>
                </dd>
              </div>
            </dl>
          )}
        </div>
      </div>
    </>
  );
}
